import { Box, Typography, useBreakpoint } from '@customink/pigment-react';

export function CartHeader() {
  const isLg = useBreakpoint('lg');
  const isXl = useBreakpoint('xl');
  const showTitle = isLg || isXl;

  return (
    <Box
      alignItems="center"
      data-testid="cart-header"
      display="flex"
      flexDirection="row"
      justifyContent="space-between"
    >
      {showTitle && (
        <Typography margin="24px 0 16px" variant="heading1">
          My Cart
        </Typography>
      )}
    </Box>
  );
}
